import PropTypes from "prop-types";

/**
 * @param {*} props.children child content to render if test === true
 * @param {func} props.renderer function that returns content to display when test === true.
 *                              Useful when rendered content relies on the value of test being truthy,
 *                              for example data in an object.
 * @param {bool} test whether or not to display the content
 * @returns rendered content
 */
function RenderIf({ children = null, test = false, renderer }) {
  if (!test) {
    return null;
  }

  if (renderer) {
    return renderer();
  }

  return children;
}

RenderIf.propTypes = {
  test: PropTypes.any,
  renderer: PropTypes.func,
  children: PropTypes.node
};

export default RenderIf;
